<template>
  <div>
    <div class="statisticContainer">
      <skeleton-card
        v-for="key in 8"
        :key="Number(key)"
        :lines="0"
        :media="false"
        :round="true"
        :is-loading="true"
        class="noMargin"
      />
    </div>
    <div class="graphicAndNotificationsContainer">
      <skeleton-card
        :avatar="false"
        :lines="13"
        :media="false"
        :round="true"
        :is-loading="true"
        class="noMargin"
      />
      <skeleton-card
        :avatar="false"
        :lines="3"
        :media="false"
        :round="true"
        :is-loading="true"
        class="noMargin"
      />
    </div>
  </div>
</template>

<script>
import SkeletonCard from 'vue-skeleton-screen'

export default {
  name: 'DashboardSkeletonCardList',
  components: { SkeletonCard },
}
</script>

<style lang="scss" scoped>
.noMargin {
  margin: 0;
}

.statisticContainer {
  margin-top: 7px;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-gap: 7px;
}

@media (max-width: 1200px) {
  .statisticContainer {
    grid-template-columns: repeat(7, 1fr);
  }
}

@media (max-width: 1034px) {
  .statisticContainer {
    grid-template-columns: repeat(6, 1fr);
  }
}

@media (max-width: 868px) {
  .statisticContainer {
    grid-template-columns: repeat(5, 1fr);
  }
}

@media (max-width: 702px) {
  .statisticContainer {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 554px) {
  .statisticContainer {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 422px) {
  .statisticContainer {
    grid-template-columns: repeat(2, 1fr);
  }
}

.graphicAndNotificationsContainer {
  margin: 7px 0;
  display: grid;
  grid-template-columns: 3fr 2fr;
  align-items: flex-start;
  gap: 7px;
}

@media (max-width: 960px) {
  .graphicAndNotificationsContainer {
    grid-template-columns: 1fr;
  }
}
</style>
